// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteScreensPrivacyScreen_wrapper"};